<div [formGroup]="serviceInputsForm" [ngClass]="{ 'insert-input': !readOnly }">
    <div formGroupName="requiredFormGroup" class="input-container date-range-container">
        <label class="input-label">{{ 'dateRange' | translate }} <span *ngIf="!readOnly" class="required-field"> *</span></label>
        <mat-form-field
            appearance="fill"
            [dir]="'rtl'"
            class="date-range date-field date-input"
            [ngClass]="{ error: invalidEndDateError }"
            (click)="onClickOpenPicker(picker)"
        >
            <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
                <input matStartDate formControlName="{{ startDateInput.controlName }}" placeholder="{{ 'startDate' | translate }}" readonly />
                <input matEndDate formControlName="{{ endDateInput.controlName }}" placeholder="{{ 'endDate' | translate }}" readonly />
            </mat-date-range-input>
            <span matPrefix class="divider"></span>
            <mat-date-range-picker
                #picker
                (closed)="onDatepickerClose(startDateInput.controlName, endDateInput.controlName)"
                [calendarHeaderComponent]="customHeader"
            >
            </mat-date-range-picker>
            <mat-hint class="hint-as-error" *ngIf="invalidEndDateError">
                {{ endDateInput.errorMessage | translate }}
            </mat-hint>
        </mat-form-field>
    </div>
</div>
